import { create } from 'zustand'
import { api } from '@/lib/api'

export interface BidMemberSummary {
  id: string
  userId: string
  fullName: string | null
  avatarUrl: string | null
}

/**
 * The bid's team, read once per bid for the bid header's avatars and the bid
 * menu's Team count. Same `GET /bids/:id/members` the page used to call itself.
 */
interface BidMembersState {
  bidId: string | null
  members: BidMemberSummary[]
  load: (bidId: string) => Promise<void>
  /** Loads only when the store holds another bid (or none). */
  ensure: (bidId: string) => Promise<void>
}

let requestId = 0

export const useBidMembersStore = create<BidMembersState>((set, get) => ({
  bidId: null,
  members: [],
  load: async (bidId) => {
    const id = ++requestId
    if (get().bidId !== bidId) set({ bidId, members: [] })
    try {
      const data = await api.get<{ members: BidMemberSummary[] }>(`/bids/${bidId}/members`)
      if (id === requestId) set({ bidId, members: data.members })
    } catch {
      // Non-critical: the header shows no avatars and the menu no count.
    }
  },
  ensure: async (bidId) => {
    if (get().bidId === bidId) return
    await get().load(bidId)
  },
}))
